module.exports = __webpack_public_path__ + "media/images/join-4-1b58f0294d6ee5133081cf1ef6da8f7a.jpg";